/*
 * Marionette LayoutView: DialogPopover
 * -------------------------
 * Marionette Layout view extended to work as our implementation of Bootstrap Popover
 */

import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import popover_target from '@/../templates/dialog-popover-target.hbs';
import popover_template from '@/../templates/dialog-popover-template.hbs';


var DialogPopover = Marionette.View.extend({
        options: {
            trigger: 'manual',
            placement: 'bottom',
            html: true,
            content: new Marionette.View.extend({
                template: "No Content"
            }),
            link_title: "",
            popover_template: popover_template,
            viewport: { "selector": "#app-container", "padding": 30 }
        },
        ui: {
            launch: '.popover-open',
            close: '.popover-close',
            contentSection: '.popover-content'
        },
        events: {
            'click @ui.launch': 'showPopover',
            'click @ui.close' : 'closePopover'
        },
        initialize: function(options) {
            _.each(Object.keys(options), function(opt){
                Marionette.getOption(opt, options[opt]);
            });
            this.template = Handlebars.compile(popover_target);
        },

        templateContext: function() {
            var data = {
                environment_name : this.options.environment_name,
                link_title : this.options.link_title
            };
            return data;
        },
        closePopover: function() {
            this.$el.find('.popover-close').hide();
            this.$el.popover('hide');
        },
        showPopover : function() {
            this.$el.find('.popover-close').show();
            this.$el.popover('show');
        },
        onRender: function() {
            this.$el.find('.popover-close').hide();
            this.$el.popover({
                     container : this.$el,
                     content: this.options.content.render().$el,
                     placement : this.options.placement,
                     template: this.options.popover_template,
                     trigger: this.options.trigger,
                     html: this.options.html,
                     viewport: this.options.viewport
            });
        }
    });
    export default DialogPopover;

